var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
import { TrayHistory } from './history/TrayHistory';
import { TrayCycles } from './modules/TrayCycles';
import { TrayAnswers } from './modules/TrayAnswers';
import { TrayBar } from './modules/TrayBar';
import { TrayTransform } from './modules/TrayTransform';
import { TrayInfo } from './modules/TrayInfo';
import { TrayLine } from './modules/TrayLine';
import { TrayPose } from './pose/TrayPose';
import { TrayFunnel } from './funnel/TrayFunnel';
export class AppTray {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get history() {
        return new TrayHistory(this);
    }
    get funnel() {
        return new TrayFunnel(this);
    }
    get pose() {
        return new TrayPose(this);
    }
    get trayCycles() {
        return new TrayCycles(this);
    }
    get trayAnswers() {
        return new TrayAnswers(this);
    }
    get trayTransform() {
        return new TrayTransform(this);
    }
    get trayInfo() {
        return new TrayInfo(this);
    }
    get trayBar() {
        return new TrayBar(this);
    }
    get trayLine() {
        return new TrayLine(this);
    }
}
__decorate([
    memoize
], AppTray.prototype, "history", null);
__decorate([
    memoize
], AppTray.prototype, "funnel", null);
__decorate([
    memoize
], AppTray.prototype, "pose", null);
__decorate([
    memoize
], AppTray.prototype, "trayCycles", null);
__decorate([
    memoize
], AppTray.prototype, "trayAnswers", null);
__decorate([
    memoize
], AppTray.prototype, "trayTransform", null);
__decorate([
    memoize
], AppTray.prototype, "trayInfo", null);
__decorate([
    memoize
], AppTray.prototype, "trayBar", null);
__decorate([
    memoize
], AppTray.prototype, "trayLine", null);
